<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Transfer</a>
            </div>
        </div>
        <div class="box-body">
            <div class="transfer">
              <el-form :model="formVal" :rules="formRules" ref="formVal" class="transfer-form" label-position="right" label-width="80px">
              <div class="transfer-desc">Transfer between existing trading accounts</div>
                <el-form-item label="From" prop="from" class="form-row">
                    <el-select v-model="formVal.from" placeholder="Please Select" @change="from_change_current_mt4_id">
                    <el-option
                      v-for="item in mt4Arr"
                      :key="item.mt4_id"
                      :label="item.mt4_id"
                      :value="item.mt4_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="To" prop="to" class="form-row">
                     <el-select v-model="formVal.to" placeholder="Please Select" @change="to_change_current_mt4_id">
                    <el-option
                      v-for="item in tomt4Arr"
                      :key="item.mt4_id"
                      :label="item.mt4_id"
                      :value="item.mt4_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Amount" prop="amount" class="form-row">
                  <el-input 
                  v-model.trim="formVal.amount"
                  @on-keyup="formVal.amount=formVal.amount.replace(/[^\d.]/g, '')"></el-input>
                  <div class="transfer-gbp">{{from_current_mt4_id.currency_type_text}}</div>
                </el-form-item>
                <div class="transfer-money"><span>{{compute_amount_val}}</span>{{to_current_mt4_id.currency_type_text}}</div>
                <el-form-item>
                  <el-button type="primary" :loading="btn_loading"  @click="submitForm('formVal')">Submit Transfer</el-button>
                </el-form-item>
              </el-form>
              <div class="transfer-tips">
                <dl>
                  <dt>Notes: </dt>
                  <dd> ZFX's market rate will be used when you transfer between trading accounts with different base currencies.</dd>
                  <dd> If you have any open trades, please ensure you still have enough funds to cover your required margin after you have transferred or withdrawn 
   funds out of your trading account, so that they are not affected. We cannot be held liable for your trades being closed out due to insufficient 
   margin level on your trading account.</dd>
                </dl>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as server from './action'
export default {
  data() {
    let msgboxOption = {
      dangerouslyUseHTMLString: true,
      center: true,
      customClass: 'transfer-msgbox',
      showClose: false
    }
    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Can not be empty'))
      }
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('Amount up to 2 decimal places'))
      } else if (Number(value) === 0) {
        callback(new Error('The amount cannot be 0'))
      } else {
        callback()
      }
    }
    return {
      mt4Arr: [],
      tomt4Arr: [],
      from_current_mt4_id: {},
      to_current_mt4_id: {},
      amountOptions: '',
      formVal: {
        from: '',
        to: '',
        amount: ''
      },
      formRules: {
        from: [{ required: true, message: 'Required.', trigger: 'blur' }],
        to: [{ required: true, message: 'Required.', trigger: 'blur' }],
        amount: [{ validator: checkAmount, trigger: 'blur' }]
      },
      btn_loading: false,
      compute_amount_val: '',
      msgboxSuccess: {
        ...msgboxOption,
        iconClass: 'ico-box ico-success',
        confirmButtonText: 'Continue'
      },
      msgboxSuccessTxt: 'Transfer successful.',
      msgboxWarning: {
        ...msgboxOption,
        iconClass: 'ico-box ico-warning',
        confirmButtonText: 'OK'
      },
      msgboxWarningTxt:
        'It appears that you have open trade(s) in your trading<br/>  account, and the amount you are withdrawing/transferring<br/> out of it has exceeded the minimum required <br/>  margin level in order to sustain the trade(s).<br/> Please try again after you have closed your position(s).',

      msgboxFailed: {
        ...msgboxOption,
        iconClass: 'ico-box ico-failed',
        confirmButtonText: 'OK'
      },
      msgboxFailedTxt:
        'Transfer failed.<br/> Insufficient balance in your originating trading account.'
    }
  },
  beforeRouteEnter(to, from, next) {
    server
      .get_transfer_info()
      .then(data => {
        next(vm => vm.setinfo(data))
      })
      .catch(() => {
        next()
      })
  },
  watch: {
    'formVal.from': {
      handler(newValue, oldValue) {
        // 大于最大金额不执行请求
        this.Mutually(newValue)
        this.compute_amount()
      },
      deep: true
    },
    'formVal.amount': {
      handler(newValue, oldValue) {
        this.compute_amount()
      },
      deep: true
    }
  },
  created() {
    // this.$alert(this.msgboxSuccessTxt, this.msgboxSuccess)
    // this.$alert(this.msgboxFailedTxt, this.msgboxFailed)
    // this.$alert(this.msgboxWarningTxt, this.msgboxWarning)
    // this.$alert(this.msgboxFailedTxt, this.msgboxFailed)
  },
  methods: {
    setinfo(val) {
      console.log('val', val)
      this.mt4Arr = val
      this.tomt4Arr = val
      console.log(this.$route.params)
      if (this.$route.params.mt4_id) {
        this.from_change_current_mt4_id(this.$route.params.mt4_id)
        this.formVal.from = this.$route.params.mt4_id
      }
    },
    Mutually(data) {
      const that = this
      const { mt4Arr = [] } = this
      that.tomt4Arr = this.copyArr(mt4Arr)
      mt4Arr.map((item, key) => {
        if (data === item.mt4_id) {
          that.tomt4Arr.splice(key, 1)
        }
      })
    },
    async compute_amount() {
      if (this.formVal.from && this.formVal.to) {
        let currency_rate = await server.get_currency_rate({
          from_mt4_id: this.formVal.from,
          to_mt4_id: this.formVal.to
        })
        let rate = currency_rate[Object.keys(currency_rate)[0]]
        this.compute_amount_val = this.toFixed(rate * this.formVal.amount)
      }
    },
    copyArr(arr) {
      return arr.map(e => {
        if (typeof e === 'object') {
          return Object.assign({}, e)
        } else {
          return e
        }
      })
    },
    from_change_current_mt4_id(value) {
      const { mt4Arr = [] } = this
      mt4Arr.map((item, key) => {
        const { mt4_id } = item
        if (value === item.mt4_id) {
          this.from_current_mt4_id = item
        }
      })
      this.formVal.to = ''
      console.log('this.formVal.to', this.formVal.to)
      this.compute_amount()
    },
    to_change_current_mt4_id(value) {
      const { tomt4Arr = [] } = this
      tomt4Arr.map((item, key) => {
        const { mt4_id } = item
        if (value === item.mt4_id) {
          this.to_current_mt4_id = item
        }
      })
      this.compute_amount()
    },
    submitForm(formName) {
      this.btn_loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.from_current_mt4_id, this.to_current_mt4_id)
          this.submit_mt4_transfer()
          console.log('submit!')
        } else {
          this.btn_loading = false
          console.log('error submit!')
          return false
        }
      })
    },
    toFixed(val) {
      /* return val.toFixed(2) */
      return val.toFixed(2)
    },
    async submit_mt4_transfer() {
      if (Number(this.formVal.amount) === 0) {
        this.$message({
          message: 'Please enter an amount greater than 0',
          type: 'warning'
        })
        this.btn_loading = false
        return false
      }

      if (
        Number(this.formVal.amount) >
        Number(this.from_current_mt4_id.balanceLeft)
      ) {
        this.$alert(this.msgboxFailedTxt, this.msgboxFailed).then(() => {})
        this.btn_loading = false
        return false
      }

      let currency_rate = await server.get_currency_rate({
        from_mt4_id: this.formVal.from,
        to_mt4_id: this.formVal.to
      })

      console.log('currency_rate', currency_rate[Object.keys(currency_rate)[0]])
      let in_money = this.toFixed(
        this.formVal.amount * currency_rate[Object.keys(currency_rate)[0]]
      )
      let params = {
        out_money: this.formVal.amount,
        in_money,
        from_mt4_id: this.formVal.from,
        to_mt4_id: this.formVal.to,
        from_currency_type: this.from_current_mt4_id.currency_type_text,
        to_currency_type: this.to_current_mt4_id.currency_type_text,
        rate: currency_rate[Object.keys(currency_rate)[0]],
        rate_key: Object.keys(currency_rate)[0]
      }
      server
        .submit_mt4_transfer(params, true)
        .then(res => {
          this.btn_loading = false
          if (res.code === 200) {
            this.$alert(this.msgboxSuccessTxt, this.msgboxSuccess).then(() => {
              this.$router.push({ name: 'TransferRecord' })
            })
          } else if (res.code === 400) {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          } else if (res.code === 500) {
            this.$alert(
              `Transfer failed.<br/>
             ${res.message}`,
              this.msgboxFailed
            ).then(() => {})
          } else if (res.code === 501) {
            this.$alert(`${res.message}`, this.msgboxWarning).then(() => {})
          }
        })
        .catch(() => {
          this.btn_loading = false
        })
    }
  },
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~assets/css/helper/variables.scss';
.transfer {
  &-form {
    width: 335px;
    margin: 40px auto 0 auto;
  }
  &-desc {
    height: 37px;
    line-height: 37px;
    background-color: #ffffff;
    // border: solid 1px #d7d7d7;
    color: #666666;
    text-align: center;
    margin-bottom: 20px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-select {
    height: 37px;
  }
  .el-button {
    display: block;
    width: 100%;
  }
  &-gbp {
    position: absolute;
    right: -40px;
    line-height: 37px;
    top: 0;
  }
  &-money {
    color: #666666;
    line-height: 1;
    margin-bottom: 30px;
    padding-left: 80px;
    span {
      color: $color-primary;
      margin-right: 10px;
    }
  }
  &-tips {
    color: #666666;
    line-height: 24px;
    dt {
      margin-bottom: 8px;
      margin-top: 52px;
    }
    dd {
      position: relative;
      padding-left: 10px;
      &:before {
        content: '*';
        color: $color-primary;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        line-height: 24px;
      }
    }
  }
  &-msgbox {
    &.el-message-box--center {
      width: 520px;
      padding: 30px 0 60px 0;
    }
    .ico-box {
      width: 60px;
      height: 60px;
      &.ico-success {
        background: url('~assets/img/ico-successful.png');
      }
      &.ico-failed {
        background: url('~assets/img/ico-failed.png');
      }
      &.ico-warning {
        background: url('~assets/img/ico-warning.png');
      }
    }

    button.el-button--primary {
      width: 253px;
      height: 42px;
      margin-top: 10px;
      background: transparent;
      background-image: linear-gradient(0deg, #fda032 0%, #fd8823 100%);
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      &:focus,
      &:hover {
        color: #fff;
        opacity: 0.9;
      }
    }
  }
  .el-select {
    display: block;
  }
}
</style>
